'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var createTypography = function createTypography(options) {
  var _options$fontFamily = options.fontFamily,
      fontFamily = _options$fontFamily === void 0 ? '"Roboto", sans-serif' : _options$fontFamily,
      _options$fontSize = options.fontSize,
      fontSize = _options$fontSize === void 0 ? 14 : _options$fontSize,
      _options$fontWeightLi = options.fontWeightLight,
      fontWeightLight = _options$fontWeightLi === void 0 ? 300 : _options$fontWeightLi,
      _options$fontWeightRe = options.fontWeightRegular,
      fontWeightRegular = _options$fontWeightRe === void 0 ? 400 : _options$fontWeightRe,
      _options$fontWeightMe = options.fontWeightMedium,
      fontWeightMedium = _options$fontWeightMe === void 0 ? 500 : _options$fontWeightMe,
      _options$fontWeightBo = options.fontWeightBold,
      fontWeightBold = _options$fontWeightBo === void 0 ? 700 : _options$fontWeightBo,
      _options$fontWeightBl = options.fontWeightBlack,
      fontWeightBlack = _options$fontWeightBl === void 0 ? 900 : _options$fontWeightBl,
      _options$htmlFontSize = options.htmlFontSize,
      htmlFontSize = _options$htmlFontSize === void 0 ? 16 : _options$htmlFontSize;
  return {
    fontFamily: fontFamily,
    htmlFontSize: htmlFontSize,
    fontSize: Math.max(fontSize, 12),
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold,
    fontWeightBlack: fontWeightBlack,
    pxToRem: function pxToRem(value) {
      return value / htmlFontSize + 'rem';
    }
  };
};

exports.default = createTypography;